import { createRouter, createWebHistory } from "vue-router";
import store from '@/store';

import WelcomePage from "@/components/WelcomePage.vue";
import RegisterView from "@/components/auth/registerView.vue";
import ModifyAccount from "@/components/auth/ModifyAccount.vue";
import ValidateEmail from "@/components/auth/ValidateEmailView.vue";
import LoginView from "@/components/auth/LoginView.vue";
import ForgotPassword from "@/components/auth/ForgotPassword.vue";
import ResetPassword from "@/components/auth/ResetPassword.vue";
/* import MailArriving from "@/components/auth/MailArriving.vue"; */

import ReferentialEditor from "@/components/admin/ReferentialEditor.vue";
import ReferentialAccess from "@/components/admin/ReferentialAccess.vue";
/* import ReferentialProjet from "@/components/admin/ReferentialProjet.vue"; */
import GeneralDataConfig from "@/components/admin/GeneralDataConfig.vue";
import DataBase from "@/components/admin/DataBase.vue";
import UserManagement from "@/components/admin/UserManagement.vue";
import ProjectManagement from "@/components/admin/ProjectManagement.vue";

import ProjectEditor from "@/components/project/ProjectEditor.vue";
/* import AnswerPage from "@/components/project/AnswerPage.vue"; */
import ProjectShareCode from "@/components/project/ProjectShareCode.vue";
import ProjectAccess from "@/components/admin/ProjectAccess.vue";
import ProjectGeneralData from "@/components/project/ProjectGeneralData.vue";
import ProjectEvaluation from "@/components/project/ProjectEvaluation.vue";
import ProjectCharts from "@/components/project/ProjectCharts.vue";

const routes = [

  /////////////////////
  // Accueil | Login //
  /////////////////////

  {
    path: "/home",
    name: "home",
    component: WelcomePage,
  },
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/login",
    name:"login",
    component: LoginView,
  },
  {
    path:"/forget",
    name:"forget",
    component: ForgotPassword,
  },
/*   {
    path:"/reset",
    name:"reset",
    component: ResetPassword
  }, */
  {
    path: "/modifyAccount",
    name: "modifyAccount",
    component: ModifyAccount,
  },
  {
    path: "/register",
    name: "register",
    component: RegisterView,
  },
  {
    path: "/users/validate/",
    name: "validateEmail",
    component:ValidateEmail, 
  },
  {
    path:"/recover/:token",
    name:"recover",
    component:ResetPassword,
  },

  /////////////////
  // Referentiel //
  /////////////////

  {
    path: "/referential",
    name: "adminReferential",
    component: ReferentialEditor,
  },
  {
    path: "/referential/:id",
    name: "adminReferentialSelected",
    component: ReferentialEditor,
  },
  {
    path: "/referential/:id/generalDataConfig",
    name: "generalDataConfig",
    component: GeneralDataConfig,
  },
  {
    path: "/referential/:id/database",
    name: "database",
    component: DataBase,
  },
  {
    path: "/referential/:id/access",
    name: "referentialAccess",
    component: ReferentialAccess,
  },
  {
    path: "/referential/:id/projects/access",
    name: "ProjectAccess",
    component: ProjectAccess,
  },
  {
    path: "/referential/projectManagement",
    name: "ProjectManagement",
    component: ProjectManagement,
  },

  /////////////
  // Project //
  /////////////

  {
    path: "/project",
    name:"Project",
    component: ProjectEditor,
  },
  /* {
    path: "/project/:id",
    name: "ProjectSelected",
    component: ProjectEditor,
  }, */
  {
    path: "/project/:id",
    name:"AnswerProject",
    component: ProjectEditor,
  },
  {
    path: "/project/:id/generalData",
    name: "projectGeneralData",
    component: ProjectGeneralData,
  },
  {
    path: "/project/:id/shareCode",
    name: "ProjectShare",
    component: ProjectShareCode
  },
  {
    path:"/project/:id/evaluation",
    name:"projectEvaluation",
    component:ProjectEvaluation
  },
  {
    path: "/project/:id/charts",
    name: "ProjectCharts",
    component: ProjectCharts
  },

  /////////////////////
  // User management //
  /////////////////////

  {
    path: "/users",
    name: "UserManagement",
    component: UserManagement,
  },
];


const router = createRouter({
  history: createWebHistory(),
  routes,
});

 
//Naviagation guard restriction (don't forget to activate the store)
router.beforeEach(async (to, from, next) => {
  const { isAuthenticated, respStatus } = store.state.auth;
  
  // Redirect if not authenticated.
    /* console.log(
    "respStatus:", respStatus,
    "isAuthenticated:", isAuthenticated,
    "to:", to,
    "from:", from,
    "\nto.meta:",to.meta
  ); */
  /* if(isAuthenticated && to.name === "login")return next('/home'); */
  if (
    respStatus === 400 &&
    from.name === "login" &&
    (to.name === "home" || to.path === "/")
  ) {
    return next('/login');
  }
   const publicRoutes = ["login", "register", "forget", "reset", "recover"];

  console.log("to after login guard:", to)
  if (!isAuthenticated && !publicRoutes.includes(to.name)) {
    console.log("Redirect to login");
    return next('/login');
  }

  next();
});

export default router;
